import { call, put, take } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import * as types from 'src/state/ducks/bakedBread/types';
import * as actions from 'src/state/ducks/bakedBread/actions';
import * as api from 'src/state/ducks/bakedBread/api';
import { Status } from 'src/constants/Interface';
import { toaster } from 'src/helpers/UtilityHelper';

function* getBakedBreads() {
  while (true) {
    const { payload } = yield take(types.GET_BAKED_BREADS);
    try {
      const res = yield call(api.getBakedBreads, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successGetBakedBreads(res));
      }
    } catch (err) {
      yield put(
        actions.failGetBakedBreads({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* getReservationBakedBreads() {
  while (true) {
    const { payload } = yield take(types.GET_RESERVATION_BAKED_BREADS);
    try {
      const res = yield call(api.getReservationBakedBreads, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successGetReservationBakedBreads(res));
      }
    } catch (err) {
      yield put(
        actions.failGetReservationBakedBreads({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* getShopBakedBreads() {
  while (true) {
    const { payload } = yield take(types.GET_SHOP_BAKED_BREADS);
    try {
      const res = yield call(api.getShopBakedBreads, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successGetShopBakedBreads(res));
      }
    } catch (err) {
      yield put(
        actions.failGetShopBakedBreads({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* createBakedBread() {
  while (true) {
    const { payload } = yield take(types.CREATE_BAKED_BREAD);
    try {
      const res = yield call(api.createBakedBread, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successCreateBakedBread(res));
        yield put(push('/baked_breads/complete'));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failCreateBakedBread(res));
      } else {
        yield put(actions.failCreateBakedBread(res));
        yield put(push('/baked_breads/complete'));
      }
    } catch (err) {
      console.error(err);
      actions.failCreateBakedBread({
        status: Status.FAILURE,
        error: {
          code: 500,
          message: err.message,
        },
      });
    }
  }
}

function* updateBakedBread() {
  while (true) {
    const { payload } = yield take(types.UPDATE_BAKED_BREAD);
    try {
      const res = yield call(api.updateBakedBread, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successUpdateBakedBread(res));
        yield put(push('/baked_breads/complete'));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failUpdateBakedBread(res));
      } else {
        yield put(actions.failUpdateBakedBread(res));
        yield put(push('/baked_breads/complete'));
      }
    } catch (err) {
      console.error(err);
      actions.failUpdateBakedBread({
        status: Status.FAILURE,
        error: {
          code: 500,
          message: err.message,
        },
      });
    }
  }
}

function* updateBakedBreadOrders() {
  while (true) {
    const { payload } = yield take(types.UPDATE_BAKED_BREAD_ORDERS);
    try {
      const res = yield call(api.updateBakedBreadOrders, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successUpdateBakedBreadOrders(res));
        toaster('success', 'パンの表示順を更新しました', 1500);
      } else {
        yield put(actions.failUpdateBakedBreadOrders(res));
      }
    } catch (err) {
      console.error(err);
      actions.failUpdateBakedBreadOrders({
        status: Status.FAILURE,
        error: {
          code: 500,
          message: err.message,
        },
      });
    }
  }
}

const bakedBreadsSaga = [
  getBakedBreads(),
  getReservationBakedBreads(),
  getShopBakedBreads(),
  createBakedBread(),
  updateBakedBread(),
  updateBakedBreadOrders(),
];

export default bakedBreadsSaga;
